<p-galleria *ngIf="this.galleryImages()[0]!=undefined && this.galleryImages()[0].previewUrl!=undefined && !this.galleryImages()[0].previewUrl.includes('item-default.jpg')" ngSkipHydration [value]="galleryImages()" [showThumbnails]="this.galleryImages().length > 1"
    [responsiveOptions]="responsiveOptions" [containerStyle]="{ 'max-width': '700px', 'margin': '0 auto' }"
    [circular]="true">

    <ng-template #item let-item>
        <div class="relative w-full h-[280px] flex items-center justify-center">
            <button
      *ngIf="!this.galleryImages()[0].previewUrl.includes('item-default.jpg')"
      class="hidden md:flex absolute top-2 right-2 items-center justify-center bg-[rgba(255,255,255,0.8)] rounded-2xl w-[30px] h-[30px] shadow-md z-10"
      (click)="displayBasic = true">
                <fa-icon
                    [icon]="faUpRightAndDownLeftFromCenter"
                    [ngClass]="isCommunity ? '!text-[var(--dark-blue)]': '!text-[var(--p-info-500)]' "
                    class="text-base ">
                </fa-icon>
            </button>
            <img [src]="item.previewUrl" [alt]="itemModal?.name" class="max-w-full h-full object-contain mx-auto" />
            <p-galleria ngSkipHydration class="hidden md:block full-screen-galleria overflow-hidden" [value]="galleryImages()" [(visible)]="displayBasic" [activeIndex]="galleryImages().indexOf(item)" [showItemNavigators]="galleryImages().length>1" [fullScreen]="true" [showThumbnails]="false" [circular]="true" appendTo="body">
                <ng-template #item let-item>
                    <div class=" flex items-center justify-center h-screen">
                        <img
                            [src]="item.originalUrl"
                            class="max-w-[90vw] max-h-[85vh] object-contain mx-auto"/>
                        <div class="inline-block align-top h-auto mt-[-50px]">
                            <button 
                            class="absolute top-4 right-4 z-50 h-[48px] w-[48px] bg-[rgba(255,255,255,0.8)] hover:bg-[rgba(255,255,255,0.9)] rounded-full ml-[-2px] mt-[2px] shadow-md"
                            (click)="displayBasic = false">
                                <fa-icon
                                    [icon]="faXmark"
                                    [ngClass]="isCommunity ? '!text-[var(--dark-blue)]': '!text-[var(--p-info-500)]' "
                                    class="!text-[30px]">
                                </fa-icon>
                            </button>
                        </div>
                    </div>
                    <div class="block sm:hidden w-[100vw] h-[100vh] bg-white">
                        <div class="flex flex justify-between">
                            <div>
                                <span  class="absolute top-2 left-5 bg-white px-3 py-0.5 text-[15px] font-mulish rounded-[10px] text-[#4A4A4A] border"
                                style="box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.3);">
                                    {{galleryImages().indexOf(item) + 1}} / {{galleryImages().length}}
                                </span>
                            </div>
                            <div>
                                <button 
                                class="h-[8vw] w-[8vw] mr-[5px] mt-[5px]"
                                (click)="displayBasic = false">
                                    <fa-icon
                                        [icon]="faXmark"
                                        class="text-[rgba(0,123,194,1)] text-base !text-[8vw]">
                                    </fa-icon>
                                </button>
                            </div>
                        </div>
                        <div class="flex items-center justify-center h-screen">
                            <img
                                [src]="item.originalUrl"
                                class="min-h-[30vw] max-w-[85vw] max-h-[85vh]"/>
                        </div>
                    </div>
                </ng-template>
            </p-galleria>
            <span  class="absolute top-0 left-0 bg-white px-3 py-0.5 text-[12px] font-mulish rounded-[10px] text-[#4A4A4A]"
            style="box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.3);">
                {{ itemModal?.lotNumber }}
            </span>
        </div>
    </ng-template>

    <ng-template #thumbnail let-item class="">
        <img [src]="item.previewUrl" [alt]="itemModal?.name"
            class="w-15 h-15 object-cover gap-6 cursor-pointer rounded-md hover:ring-2 hover:ring-blue-400 transition" />
    </ng-template>
</p-galleria>
<div *ngIf="this.galleryImages()[0]==undefined || this.galleryImages()[0].previewUrl.includes('item-default.jpg')"
    class="flex flex-col">
    <span  class="z-10 mb-[-23px] ml-[1px] bg-white w-fit px-3 py-0.5 text-[12px] font-mulish rounded-[10px] text-[#4A4A4A]"
    style="box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.3);">
        {{ itemModal?.lotNumber }}
    </span>
    <app-default-image [element]="'imageFull'"></app-default-image>
    
</div>
